module.exports = __webpack_public_path__ + "img/Image 53.b98ccf34.png";